<template>
  <custom-dialog :visible="visible" width="680px" class="order-close-dialog" :title="$t('crm_order_close_dialog.guan_bi_ding_dano', [model.contractNo])" v-on="$listeners">
    <div class="dialog-body">
      <div class="input-container">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item :label="$t('crm_order_close_dialog.guan_bi_yuan_yin')" prop="closeReason">
            <el-input type="textarea" :rows="3"  v-model="form.closeReason"  style="width:100%;">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        closeReason: '',
        orderId: ''
      },
    };
  },
  mounted: function () {
    this.form.orderId = this.model.bizId || '';
  },

  computed: {
    rules() {
      return {
        closeReason: [{
          required: true,
          message: this.$t('crm_order_close_dialog.qtxgbyy')
        }],

      };
    },
  },
  methods: {
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.$postJSON(apis.trialOrderClose, this.form, true).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.visible = false;
            this.$emit('success');
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.device-warehousing-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }

  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    .msg-content {
      width: 260px;
      padding: 0 24px 40px;
      height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
